// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production48Filled: FC<Production48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path
                d="M18.332 43.123c.063.501.495.877 1.008.877h9.32a1.01 1.01 0 0 0 1.008-.877l.636-5.036a1 1 0 0 1 .491-.737l.64-.373.02-.01.848-.474c.276-.153.608-.172.899-.05l4.672 1.96a1.023 1.023 0 0 0 1.278-.421l4.662-7.97a.99.99 0 0 0-.265-1.295l-4.093-3.067a.995.995 0 0 1-.4-.796v-.365c0-.185 0-.547.031-1.37a.99.99 0 0 1 .399-.753l4.113-3.083a.99.99 0 0 0 .265-1.295l-4.663-7.972a1.023 1.023 0 0 0-1.275-.422l-4.739 1.97a1.014 1.014 0 0 1-.872-.042c-.278-.15-.63-.346-.861-.488-.197-.121-.441-.264-.648-.383a1.013 1.013 0 0 1-.503-.748l-.635-5.026A1.01 1.01 0 0 0 28.66 4h-9.32a1.01 1.01 0 0 0-1.008.877l-.637 5.04a1.002 1.002 0 0 1-.485.734l-.417.249-.334.195c-.273.157-.5.28-.77.425a1.03 1.03 0 0 1-.88.043l-4.735-1.97a1.023 1.023 0 0 0-1.275.423l-4.663 7.972a.99.99 0 0 0 .265 1.295l4.092 3.067c.252.189.4.483.4.796v1.708a.995.995 0 0 1-.4.796l-4.092 3.067a.99.99 0 0 0-.265 1.295l4.663 7.972c.256.438.803.618 1.275.422l4.715-1.96a1.03 1.03 0 0 1 .91.06l.69.4.016.01.784.436a1 1 0 0 1 .508.747l.635 5.024ZM24 30.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production48Filled;
